module.exports = __webpack_public_path__ + "img/error-5xx.a0308d20.svg";